module.exports = __webpack_public_path__ + "img/67.8efaf91d.jpg";